<template>
  <div class="bms-tickets">
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  provide () {
    return {
      loginState: () => {
        return this.getLogin()
      }
    }
  },
  data () {
    return {
      state_pop: false,
      state_text: '链接失效了'
    }
  },
  computed: {
    ...mapState(['params', 'link_able', 'logined'])
  },
  created () {
    this.$sensors.track('registerPage', {
      type: 'couponActivity'
    })
    // 领取优惠券按钮 验证插件初始化
    this.$store.dispatch('initPlugin')
    this.$sensors.track('quick', 'autoTrack')
  },
  methods: {
    getLogin () {
      return new Promise(resolve => {
        if (this.$store.state.env) {
          resolve(this.$store.state.logined)
        } else {
          setTimeout(() => {
            this.getLogin().then(res => {
              resolve(res)
            })
          }, 500)
        }
      })
    }
  }
}
</script>

<style lang="less">

@import './src/assets/reset.less';

.state-pop {
  box-sizing: border-box;
  width: 340px;
  height: 180px;
  padding: 0 24px;
  overflow: hidden;
  border-radius: 12px;

  .pop-content {
    .ttl {
      min-height: 32px;
      margin-top: 40px;
      font-size: 18px;
      font-weight: 500;
      line-height: 32px;
      color: #633649;
      text-align: center;
      letter-spacing: 1px;
    }

    .line-btn {
      width: 277px;
      margin: 0 auto;
      margin-top: 32px;
      font-size: 15px;
      font-weight: 500;
      text-align: center;
    }
  }

  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
    width: 20px;
    height: 20px;
  }
}

.bms-tickets {
  #launch-btn_tl2 {
    display: block;
    width: 100%;
  }

  #launch-btn_tl {
    display: block;
    width: 100%;
  }
}

</style>
